<template>
  <component
    :is="tagName"
    ref="scrollable"
    :class="[scrollClasses, 'overflow-auto', { hideScrollBar }]"
  >
    <slot />
  </component>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ScrollComponent",
  components: {},
  props: {
    tagName: {
      type: String,
      default: "div",
    },
    fillScrollBarMissingWithPadding: {
      type: Boolean,
      default: false,
    },
    hideScrollBar: {
      type: Boolean,
      default: false,
    },
    customTagSelector: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      scrollClasses: "",
    };
  },
  mounted() {
    this.setNewElementClasses();
    if (this.customTagSelector) {
      this.observerResize(this.customTagSelector, this.setNewElementClasses);
    } else
      this.observerResize(this.$refs.scrollable, this.setNewElementClasses);

    if (this.customTagSelector) {
      setInterval(() => {
        this.setNewElementClasses();
      }, 5000);
    }
  },
  methods: {
    observerResize(element, callback) {
      if (typeof element === "string")
        element = document.querySelector(element);
      if (!element) return;
      let observer = new ResizeObserver(function (entries) {
        // since we are observing only a single element, so we access the first element in entries array
        let rect = entries[0].contentRect;

        // current width & height
        let width = rect.width;
        let height = rect.height;

        callback(width, height);
      });
      observer.observe(element);
    },
    setNewElementClasses() {
      if (this.hideScrollBar) {
        this.scrollClasses = "";
        return;
      }
      let element = this.customTagSelector
        ? document.querySelector(this.customTagSelector)
        : this.$refs.scrollable;
      if (!element) return;
      let classes = this.generateClassesForElement(
        element,
        this.fillScrollBarMissingWithPadding
      );
      this.scrollClasses = classes;
    },

    generateClassesForElement(element, usePadding = false) {
      if (!element) return "";
      const scrollX = element.scrollWidth > element.offsetWidth;
      const scrollY = element.scrollHeight > element.offsetHeight;
      let classes = "fill-scroll-gap";
      if (scrollX) classes += " scrollX ";
      if (scrollY) classes += " scrollY ";
      if (usePadding) classes += " fill-scroll-gap-with-padding ";
      else classes += " fill-scroll-gap-with-margin ";
      return classes;
    },
  },
  watch: {
    scrollClasses(newClasses) {
      if (!this.customTagSelector) return;
      const element = document.querySelector(this.customTagSelector);
      if (!element) return;
      newClasses.split(" ").forEach((className) => {
        if (!className) return;
        element.classList.add(className);
      });
    },
  },
});
</script>


<style >
* {
  --scroll-bar-size-mobile: 3px;
  --scroll-bar-size-desktop: 7px;
}

@media only screen and (min-width: 1024px) {
  body.overflow-auto::-webkit-scrollbar-thumb {
    border-radius: 5px;
  }

  .overflow-auto::-webkit-scrollbar-track {
    background-color: theme("colors.slate.100");
    background-color: transparent;
    background-color: #f0f1f6;
    border-radius: 0px;
  }

  .overflow-auto::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  .overflow-auto::-webkit-scrollbar {
    background: theme("colors.slate.400");
  }

  .overflow-auto::-webkit-scrollbar-thumb {
    background: theme("colors.slate.400");
  }

  .overflow-auto::-webkit-scrollbar-thumb:hover {
    background: theme("colors.slate.700");
  }

  .overflow-auto::-webkit-scrollbar-thumb:active {
    background: theme("colors.slate.700");
  }

  .overflow-auto::-webkit-scrollbar-corner {
    background: theme("colors.slate.400");
  }

  .overflow-auto::-webkit-scrollbar {
    width: var(--scroll-bar-size-desktop);
    height: var(--scroll-bar-size-desktop);
  }

  .overflow-auto.scrollY.fill-scroll-gap,
  .overflow-auto.scrollX.fill-scroll-gap {
    transition-duration: 0s;
  }

  .overflow-auto.scrollY.fill-scroll-gap:not(:hover)::-webkit-scrollbar,
  .overflow-auto.scrollX.fill-scroll-gap:not(:hover)::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    transition-duration: 0s;
  }

  .overflow-auto.scrollY.fill-scroll-gap-with-margin:not(.hideScrollBar):not(
      :hover
    ) {
    margin-right: var(--scroll-bar-size-desktop);
  }

  .overflow-auto.scrollY.fill-scroll-gap-with-padding:not(.hideScrollBar):not(
      :hover
    ) {
    padding-right: var(--scroll-bar-size-desktop);
  }

  .overflow-auto.scrollX.fill-scroll-gap-with-margin:not(.hideScrollBar):not(
      :hover
    ) {
    margin-bottom: var(--scroll-bar-size-desktop);
  }

  .overflow-auto.scrollX.fill-scroll-gap-with-padding:not(.hideScrollBar):not(
      :hover
    ) {
    padding-bottom: var(--scroll-bar-size-desktop);
  }

  .hideScrollBar::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
  }
}

/* @media only screen and (max-width: 1024px) {
  .overflow-auto::-webkit-scrollbar {
    width: var(--scroll-bar-size-mobile);
    height: var(--scroll-bar-size-mobile);
  }
} */
</style>